import { createAction } from 'redux-actions'
import { selectors as coreSelectors, clientFactory } from 'mage-core'
import * as constants from './constants'
import * as selectors from './selectors'
import eventTypes, { userEventTypes } from './eventTypes'
import handleEducationError from './handleEducationError'

export const setEducationFeatures = createAction(constants.SET_EDUCATION_FEATURES)
export const setPrivateEducationFeaturesLoaded = createAction(
  constants.SET_IS_AUTHENTICATED_FEATURES_LOADED
)
export const setMerchantEducationEvents = createAction(constants.SET_EDUCATION_EVENTS)
export const addEducationEvent = createAction(constants.ADD_EDUCATION_EVENT)

export const setEducationEventsPending = createAction(constants.SET_EDUCATION_EVENTS_PENDING)

export function fetchEducationEvents() {
  return (dispatch, getState) => {
    const state = getState()
    const pending = selectors.merchantEducationEventsPending(state)
    if (pending) {
      dispatch(setEducationEventsPending(false))
      return selectors
        .educationClient(state)
        .request({ method: 'GET', url: `/v1/events` })
        .then(response => dispatch(setMerchantEducationEvents(response.data.events)))
        .catch(handleEducationError)
    }
  }
}

export function fetchEducationPayoutEvent() {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const settlementsClient = clientFactory(state)('/api/settlements')
      const merchantId = coreSelectors.getMerchantIds(state)[0]
      const probeResponse = await settlementsClient.request({
        method: 'GET',
        url: `/settlements`,
        params: { merchant_id: merchantId, size: 1 }
      })

      if (probeResponse.data.pagination.total > 0) {
        const response = await settlementsClient.request({
          method: 'GET',
          url: `/settlements`,
          params: {
            merchant_id: merchantId,
            size: 1,
            offset: probeResponse.data.pagination.total - 1
          }
        })

        const settlement = response.data.elements[0]

        const data = {
          eventType: eventTypes.FIRST_PAYOUT,
          eventAt: settlement.payout_date,
          payload: settlement
        }

        const result = await submitNewEducationProfileEvent(dispatch, getState, data)

        return result
      }
    } catch (error) {
      handleEducationError(error)
    }
  }
}

export function createEducationProfileEvent(eventType, eventAt = new Date().toISOString()) {
  return (dispatch, getState) => {
    const data = { eventType, eventAt }
    const isUserEvent = Boolean(userEventTypes[eventType])

    return submitNewEducationProfileEvent(dispatch, getState, data, isUserEvent).catch(
      handleEducationError
    )
  }
}

async function submitNewEducationProfileEvent(dispatch, getState, data, isUserEvent) {
  const state = getState()
  const merchantId = coreSelectors.getMerchantIds(state)[0]
  const realm = coreSelectors.keycloakRealm(state)

  if (realm === 'merchants') {
    const url = isUserEvent ? '/v1/user/events' : `/v1/merchant/${merchantId}/events`

    await selectors.educationClient(state).request({
      method: 'POST',
      url,
      data
    })

    dispatch(addEducationEvent(data))
    dispatch(setEducationEventsPending(true))
    dispatch(fetchEducationEvents())
  }
}
